import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ref, onValue } from "firebase/database";
import { db } from "../firebase";
import DailyEntryForm from "./DailyEntryForm";

// Get today's date in LOCAL time as YYYY-MM-DD (avoids UTC off-by-one)
function getLocalDateString(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export default function DailyEntryPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [areaId, setAreaId] = useState(null);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [date, setDate] = useState(() => getLocalDateString());

  const todayStr = getLocalDateString();

  useEffect(() => {
    const areasRef = ref(db, "areas");
    const unsubscribe = onValue(areasRef, (snap) => {
      const areas = snap.val() || {};
      const found = Object.entries(areas).find(
        ([, v]) => v.meta && v.meta.slug === slug
      );

      if (found) {
        setAreaId(found[0]);
        setMeta(found[1].meta);
      } else {
        setAreaId(null);
        setMeta(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, [slug]);

  return (
    <div
      style={{
        background: "#fff",
        color: "#000",
        minHeight: "100vh",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h3 style={{ textAlign: "center", marginBottom: 10 }}>Daily entry page</h3>
      <h4 style={{ textAlign: "center", marginBottom: 20 }}>
        Area name:{" "}
        {loading ? "Loading..." : meta?.name || "Unknown"}
      </h4>

      <div
        style={{
          maxWidth: 800,
          margin: "0 auto",
          background: "#ffffff",
          border: "1px solid #ccc",
          padding: "20px 40px",
          borderRadius: 8,
        }}
      >
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontWeight: "bold", marginRight: 10 }}>Date:</label>
          <input
            type="date"
            value={date}
            max={todayStr}
            onChange={(e) => setDate(e.target.value)}
            style={{
              padding: "5px 10px",
              border: "1px solid #999",
              borderRadius: 4,
            }}
          />
          {date !== todayStr && (
            <span
              style={{
                marginLeft: 12,
                fontSize: 13,
                color: "#856404",
                background: "#fff3cd",
                padding: "3px 8px",
                borderRadius: 4,
              }}
            >
              ⚠️ Backdated entry
            </span>
          )}
        </div>

        {areaId ? (
          <DailyEntryForm key={`${areaId}-${date}`} areaId={areaId} date={date} />
        ) : (
          <div
            style={{
              textAlign: "center",
              color: "red",
              fontWeight: 600,
              marginTop: 40,
            }}
          >
            {loading
              ? "Loading area..."
              : "Area not selected or no customers found."}
          </div>
        )}

        <div style={{ textAlign: "center", marginTop: 20 }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              padding: "8px 20px",
              borderRadius: 5,
              border: "1px solid #000",
              background: "#f8f8f8",
              cursor: "pointer",
            }}
          >
            Back
          </button>
        </div>
      </div>
    </div>
  );
}